<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="100px">
        <el-row :gutter="24">
          <el-col :span="23">
            <el-form-item label="入住状态" prop="occupancyStatusName">
              <el-input clearable disabled v-model="form.occupancyStatusName" placeholder="请选择入住状态"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item label="床位" prop="bedName">
              <el-input clearable disabled v-model="form.bedName" placeholder="请输入床位"
                maxlength="20"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="23">
            <el-form-item label="入住日期" prop="signInTime">
              <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd"
                v-model="form.signInTime" type="date" placeholder="请选择入住日期">
              </el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
    </div>
    <div style="text-align: right">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small">
        保存
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
<script>
import {
  saveMove,
} from '../../api/serveItemManage';
import { dateFormat } from '@/util/date';
export default {
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
  },
  data() {
    return {
      form: {
        occupancyStatus: '',
        signInTime: '',
        bedId: '',
        bedName: '',
      },
      formRules: {
        signInTime: [{ required: true, message: '入住日期不能为空', trigger: 'change' }],
      },
    };
  },
  created() {
    this.initData();
  },
  mounted() { },
  watch: {},
  methods: {
    async initData() {
      // getDictionary('nursinghome_fee_type').then((res) => {
      //   this.causeList = res.data;
      // })
        this.form = this._.cloneDeep(this.row);
        console.log(this.form, 'form');
        this.form.occupancyStatusName = '已入住'
        this.form.signInTime = dateFormat(new Date()).split(' ')[0]
    },

    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          let params = { nursinghomeId: this.row.nursinghomeId, elderlyId: this.row.id, ...this.form }
          params.signInTime = params.signInTime ? params.signInTime + ' 00:00:00' : ''
          params.contractExpirationTime = params.contractExpirationTime ? params.contractExpirationTime + ' 23:59:59' : ''
          params.leaveDate = params.leaveDate ? params.leaveDate + ' 00:00:00' : ''
          saveMove(params).then((res) => {
            this.$message.success('操作成功！');
            this.$emit('success');
          });
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}

::v-deep .el-col-8 {
  height: 54px;
}

.title {
  line-height: 50px;
  font-weight: bolder;
  font-size: 18px;
  margin-bottom: 10px;
}
</style>
